import(/* webpackMode: "eager" */ "/data1/service/src/app/(tabbar)/tabbar.module.css");
import(/* webpackMode: "eager" */ "/data1/service/src/components/FooterBar/index.js")